import styled from "styled-components";

export const Images = styled.img`
  max-width: 50%;
  max-height: 25%;
  border-radius: 10px;
  margin: 10px;
  float: left;
`;
